import { ScriptView } from './scripts/index.js'

// register the one and only choo route on all paths
export function registerRoutes(app) {
  const view = new ScriptView()
  const boundView = view.render.bind(view)
  app.route('*', boundView)
}
